import { Flashbar, FlashbarProps } from '@amzn/awsui-components-react-v3';
import { Link } from 'src/components/common/Link';
import React, { useEffect, useState } from 'react';
import { Advisory } from 'aws-sdk/clients/awsdlomni';
import { createAdvisoryDetailsLink } from 'src/routes';
import { addDismissedAdvisory, getDismissedAdvisories } from 'src/components/dataadvisory/announcements/common';

export interface ActiveAdvisoriesHeaderProps {
  // passed in from App component from a listAdvisories call, these will be filtered by which advisories the user has already dismissed
  activeAdvisories: Advisory[];
}

export const ActiveAdvisoriesHeader = (props: ActiveAdvisoriesHeaderProps) => {
  const getAdvisoriesToDisplay = async () => {
    const dismissedAdvisories = await getDismissedAdvisories();

    let advisories = [];
    if (props.activeAdvisories?.length > 0) {
      advisories = props.activeAdvisories.filter((advisory) => !dismissedAdvisories.includes(advisory.advisoryId));
    }

    setAdvisoriesToDisplay(advisories);
  };

  const [advisoriesToDisplay, setAdvisoriesToDisplay] = useState([]);

  // add the advisory ID to the dismissed advisories in browser storage, and set state accordingly
  const handleDismiss = async (advisory: Advisory) => {
    await addDismissedAdvisory(advisory);
    await getAdvisoriesToDisplay();
  };

  // re-render when there is a change in active advisories in props.
  useEffect(() => {
    getAdvisoriesToDisplay();
  }, [props.activeAdvisories]);

  const items: FlashbarProps.MessageDefinition[] = advisoriesToDisplay.map((advisory: Advisory) => ({
    type: 'warning',
    content: (
      <>
        There is an active advisory for data you consume:{' '}
        <Link href={createAdvisoryDetailsLink(advisory.advisoryId)}>{advisory.title}</Link>{' '}
      </>
    ),
    dismissible: true,
    onDismiss: () => handleDismiss(advisory),
  }));

  if (advisoriesToDisplay.length == 0) {
    return <></>;
  }
  return <Flashbar items={items} />;
};
